<template>
<div id="selectContent">
    <van-cell :title="value" is-link @click="isShow=true">
        <template #icon>
            <span>{{title}}</span>
        </template>
    </van-cell>
    <van-popup 
        v-model="isShow"
        :close-on-click-overlay="false"
        round position="bottom"
        >
        <van-picker
            show-toolbar
            :columns="columns"
            :default-index="this.index"
            get-container="#selectContent"
            @confirm="onConfirm"
            @cancel="onCancel"
            @change="onChange"
            />
    </van-popup >
</div>
</template>

<script>
import { Toast } from 'vant';
export default {
    props:["title","columns","index"],
    data(){
        return{
           isShow:false,
        //    title:"保障期限",
           value:this.columns[this.index],
        }
    },
    methods: {
        onConfirm(value, index) {
            this.value=value;
            this.closeProp();
        },
        onChange(picker, value, index) {
        },
        onCancel() {
            this.closeProp();
        },
        closeProp(){
            this.isShow=false;
        },
    },
    watch:{
        // unit(e){
        //     console.log(e)
        // }
    },
    computed:{
        units:{
            get(){
                let unit;
                if(this.unit===undefined){
                    console.log("*",this.unit)
                    unit=""
                }else{
                    unit=this.unit
                }
                return unit;
            },
            set(newValue){
                return newValue
            }
        }
    },
}
</script>

<style scoped>
 .van-cell{
        padding-left: 0;
        padding-right: 0;
    }
    .van-cell__title {
        text-align: right;
        margin-left: 20px;
    }
 #selectContent /deep/ .van-picker-column__item--selected{
      border-top:1px solid #f00;
      border-bottom:1px solid #f00;
  }
  #selectContent /deep/ .van-picker__columns {
      width: 80%;
      margin: 0 auto;
  }
  #selectContent /deep/ .van-picker__confirm{
     color:  rgba(243,71,64,1) ;
  }
</style>


// WEBPACK FOOTER //
// src/components/select.vue